import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";
import { fetchCommonJobOptions } from "model/JobModel";

const normalizeSelectOptions = (payload) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.records)
                ? payload.records
                : Array.isArray(payload?.rows)
                    ? payload.rows
                    : [];

    return list
        .map((item) => {
            const value = String(
                item?.value ?? item?.id ?? item?._id ?? item?.jobId ?? item?.key ?? ""
            ).trim();
            const label = String(
                item?.label ??
                    item?.display ??
                    item?.data ??
                    item?.name ??
                    item?.title ??
                    item?.jobName ??
                    value
            ).trim();
            if (!value) return null;
            return { value, label: label || value };
        })
        .filter(Boolean);
};

/** POST `Report/closure/filter` */
export const submitClosureReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CLOSURE_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `common/job` — job dropdown for closure report filter. */
export const fetchClosureReportJobOptions = async (data = {}) => {
    try {
        const response = await fetchCommonJobOptions(data);
        const records =
            response?.data?.records ??
            response?.data?.data ??
            response?.data ??
            response?.records ??
            response ??
            [];
        return normalizeSelectOptions(records);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};
